module.exports = __webpack_public_path__ + "staticcomp/img/content_3.7d3c0ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/7/content_3.jpg
// module id = MiFu
// module chunks = 39